import { render } from "./TermsOfUseView.vue?vue&type=template&id=4c6fbb05"
import script from "./TermsOfUseView.vue?vue&type=script&lang=js"
export * from "./TermsOfUseView.vue?vue&type=script&lang=js"

import "./TermsOfUseView.vue?vue&type=style&index=0&id=4c6fbb05&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__